import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  OptionalFeatureBase,
} from "@models";
import { 
  Character,
  CharacterClass,
  // CharacterFeature,
  CharacterFeatureBase,
  CharacterFeatureSource,
  CharacterSheetInterface,
  SubclassFeature,
} from "@dndModels";

// import API from "../../../utilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../../utilities/common_utilities';

import CharacterFeatureBaseInput from "@dndComponents/character/features/CharacterFeatureBaseInput";
import CharacterFeatureBaseOptionsInput from "@dndComponents/character/features/CharacterFeatureBaseOptions";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LoadingBox from "@components/input/LoadingBox";

import CenteredMenu from "@components/input/menus/CenteredMenu";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import CharacterFeatureInput from "@dndComponents/character/features/CharacterFeatureInput";


interface Props {
  char: CharacterSheetInterface;
  source: CharacterFeatureSource;
  log_it?: boolean;
  // onChange: (do_main: boolean) => void;
}

// const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterFeatureSourceInput({
  char,
  source,
  log_it = false,
  // onChange
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [show_description, setShowDescription] = useState(false);
  const [show_features, setShowFeatures] = useState(true);
  const [view, setView] = useState("Current Features");
  const [optional_feature_bases, setOptionalFeatureBases] = useState<OptionalFeatureBase[]>([]);

  const [selected_cfb, setSelectedCFB] = useState<CharacterFeatureBase | null>(null);
  const [show_desc, setShowDesc] = useState(false);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = async () => {
    setOptionalFeatureBases(await char_util.get_optional_features(source));
    setFetched(true);
  }

  const getCharFeatureBasesForRender = (char_feature_bases: CharacterFeatureBase[]) => {
    const use_char_feature_bases = char_feature_bases.filter(o => o.feature_base &&
      (o.feature_base.required_condition_ids.length === 0 || 
        char_util.hasCondition(char, o.feature_base.required_condition_ids, o.feature_base.condition_level)) && 
      (!o.replace_key || o.replaces_cfb_on_source_id !== "")
    );
    return use_char_feature_bases.filter(o => o.display).sort((a, b) => { 
      if (a.feature_base && b.feature_base) {
        if (+a.sort_level === +b.sort_level) {
          if (a.ancestries.length === b.ancestries.length) {
            return a.name.localeCompare(b.name);
          } else {
            return (+a.ancestries.length < +b.ancestries.length ? -1 : 1);
          }
        } else {
          return (+a.sort_level < +b.sort_level ? -1 : 1);
        }
      } else {
        return 1;
      }
    });
  }

  const renderCharFeatureBases = (char_feature_bases: CharacterFeatureBase[]) => {
    const cfbs = getCharFeatureBasesForRender(char_feature_bases);
    if (log_it) {
      console.log(char_feature_bases);
      console.log(cfbs);
    }

    if (window.innerWidth > 800) {
      return (
        <Grid
          key="char_feature_bases"
          container
          spacing={0}
          direction="row"
          size={{
            xs: 12
          }}>
          <Grid
            size={{
              xs: 4
            }}>
            <div style={{ maxHeight: window.innerHeight - 235, overflowY: "auto" }}>
              <Grid container spacing={0} direction="row">
                { cfbs.map((cfb, i) => {
                  return (
                    <Grid
                      key={i}
                      size={{
                        xs: 12
                      }}>
                      <CharacterFeatureBaseInput
                        char={char}
                        source={source}
                        obj={cfb}
                        onSelect={() => {
                          setSelectedCFB(cfb);
                          setReloading(true);
                        }}
                        selected={selected_cfb !== null && cfb.true_id === selected_cfb.true_id}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </Grid>
          <Grid
            size={{
              xs: 8
            }}>
            <div style={{ maxHeight: window.innerHeight - 235, overflowY: "auto" }}>
              { !reloading &&
                <>
                  { selected_cfb ? 
                    <Grid container spacing={0} direction="row">
                      { selected_cfb.feature_base && 
                        selected_cfb.feature_base.description !== "" &&
                        (selected_cfb.features.length !== 1 || 
                          !(selected_cfb.features[0].floating_feature && 
                            selected_cfb.features[0].floating_feature.description === selected_cfb.feature_base.description)) &&
                        <Grid
                          size={{
                            xs: 12
                          }}>
                          { selected_cfb.feature_base.description.length < 30 || selected_cfb.features.length === 0 ?
                            <DisplayStringWithReplacements
                              display_string={selected_cfb.feature_base.description}
                            />
                          :
                            <Grid container spacing={0} direction="column">
                              <Grid>
                                <ToggleButtonBox 
                                  name={ show_desc ? "Hide Description" : "Show Description" }
                                  value={show_desc}
                                  onToggle={() => {
                                    setShowDesc(!show_desc);
                                  }}
                                />
                              </Grid>
                              { show_desc &&
                                <Grid>
                                  <DisplayStringWithReplacements display_string={ selected_cfb.feature_base.description } />
                                </Grid>
                              }
                            </Grid>
                          }
                        </Grid>
                      }
                      { selected_cfb.features.map((feature, key) => {
                        if (feature.feature) {
                          return (
                            <Grid
                              key={key}
                              size={{
                                xs: 12
                              }}>
                              <CharacterFeatureInput 
                                obj={feature}
                                char={char}
                                source={source}
                              />
                            </Grid>
                          );
                        }
                        return null;
                      })}
                    </Grid>
                  :
                    <Grid container spacing={0} direction="row">
                      <Grid
                        size={{
                          xs: 12
                        }}>
                        <DisplayStringWithReplacements
                          display_string={source.description}
                        />
                      </Grid>
                      <Grid
                        size={{
                          xs: 12
                        }}>
                        <DisplayStringWithReplacements
                          display_string={source.notes}
                        />
                      </Grid>
                    </Grid>
                  }
                </>
              }
            </div>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <Grid
          key="char_feature_bases"
          container
          spacing={0}
          direction="row"
          size={{
            xs: 12
          }}>
          { cfbs.map((cfb, i) => {
            return (
              <Grid
                key={i}
                size={{
                  xs: 12
                }}>
                <CharacterFeatureBaseInput
                  char={char}
                  source={source}
                  obj={cfb}
                />
              </Grid>
            );
          })}
        </Grid>
      );
    }
  }

  if (!fetched) {
    return (<LoadingBox />);
  } else {
    const return_us: any[] = [];
    if (window.innerWidth <= 800) {
      return_us.push(
        <Grid
          key="Show/Hide Desc"
          size={{
            xs: 12
          }}>
          <ToggleButtonBox 
            name={ show_description ? "Hide Description" : "Show Description" }
            value={show_description}
            onToggle={() => {
              setShowDescription(!show_description);
            }}
          />
        </Grid>
      );
      if (show_description) {
        return_us.push(
          <Grid
            key="Description"
            size={{
              xs: 12
            }}>
            <DisplayStringWithReplacements
              display_string={source.description}
            />
          </Grid>
        );
      }
    }
    return_us.push(
      <Grid
        key="Show/Hide Features"
        size={{
          xs: 12
        }}>
        <ToggleButtonBox 
          name={ show_features ? "Hide Features" : "Show Features" }
          value={show_features}
          onToggle={() => {
            setShowFeatures(!show_features);
          }}
        />
      </Grid>
    );
    if (log_it) {
      console.log(source);
    }
    if (show_features) {
      const optional = view === "Optional Features";
      if (optional) {
        if (source instanceof CharacterClass) {
          const char_class = source as CharacterClass;
          if (char_class.level >= 1) {
            return_us.push(
              <Grid
                key="Optional"
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <CenteredMenu 
                    selected={view}
                    options={["Current Features","Optional Features"]} 
                    onSelect={setView}                      
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  { char instanceof Character && 
                    <CharacterFeatureBaseOptionsInput 
                      character={char}
                      char_feature_source={source}
                      optional_feature_bases={ optional_feature_bases }
                      onChange={(_id: string, value: boolean) => {
                        // TODO: Make it work for upgrading feature bases.  
                        // It works similar to replacing
                        if (value) {
                          char.spirit.optional_feature_base_ids.push(_id);
                        } else {
                          char.spirit.optional_feature_base_ids = char.spirit.optional_feature_base_ids.filter(o => o !== _id);
                        }
                        char.changed();
                        char.subscription_holder.recalculate();
                      }}
                    />
                  }
                </Grid>
              </Grid>
            );
          } else if (char_class.level > 0) {
            if (char_class.source) {
              const fs = char_class.source;
              const level1_fbs = fs.feature_bases.filter(o => o.level === 1 && o.multiclassing !== 2);
              return_us.push(
                <Grid
                  key="Optional"
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 12
                  }}>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    <CenteredMenu 
                      selected={view}
                      options={["Current Features","Optional Features"]} 
                      onSelect={setView}                      
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                      I want to get rid of level_0_feature_ids. Not sure what's happening here.
                      { char instanceof Character && 
                        <CharacterFeatureBaseOptionsInput 
                          character={char}
                          char_feature_source={char_class}
                          feature_bases={ level1_fbs }
                          onChange={(_id: string, value: boolean) => {
                            // if (value) {
                            //   char.level_0_feature_ids.push(_id);
                            // } else {
                            //   char.level_0_feature_ids = char.level_0_feature_ids.filter(o => o !== _id);
                            // }
                            char.changed();
                            char.subscription_holder.recalculate();
                          }}
                        />
                      }
                  </Grid>
                </Grid>
              );
            }
          }
        } else {
          return_us.push(
            <Grid
              key="Optional"
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                size={{
                  xs: 12
                }}>
                <CenteredMenu 
                  selected={view}
                  options={["Current Features","Optional Features"]} 
                  onSelect={setView}                      
                />
              </Grid>
              <Grid
                size={{
                  xs: 12
                }}>
                { char instanceof Character && 
                  <CharacterFeatureBaseOptionsInput 
                    character={char}
                    char_feature_source={source}
                    optional_feature_bases={ optional_feature_bases }
                    onChange={(_id: string, value: boolean) => {
                      // TODO: Make it work for upgrading feature bases.  
                      // It works similar to replacing
                      if (value) {
                        char.spirit.optional_feature_base_ids.push(_id);
                      } else {
                        char.spirit.optional_feature_base_ids = char.spirit.optional_feature_base_ids.filter(o => o !== _id);
                      }
                      char.changed();
                      char.subscription_holder.recalculate();
                    }}
                  />
                }
              </Grid>
            </Grid>
          );
        }
      } else if (source instanceof CharacterClass) {
        const char_class = source as CharacterClass;
        if (char_class.source) {
          const combined_features = char_util.useFeatures2(char, char_class, true, log_it);
          // const subclass_features = char_class.char_subclass ? char_util.use_features(character, char_class.char_subclass) : [];
          // const combined_features = [...class_features,...subclass_features];
          if (char instanceof Character && char.c_options.optional_features) {
            return_us.push(
              <Grid
                key="header"
                container
                spacing={0}
                direction="row"
                size={{
                  xs: 12
                }}>
                <Grid
                  size={{
                    xs: 12
                  }}>
                  <CenteredMenu 
                    selected={view}
                    options={["Current Features","Optional Features"]} 
                    onSelect={setView}                      
                  />
                </Grid>
              </Grid>
            );
          }
          const char_feature_bases = combined_features.sort((a, b) => (a.feature_base && b.feature_base && a.feature_base.level > b.feature_base.level) ? 1 : -1);
          return_us.push(renderCharFeatureBases(char_feature_bases));
        }
      } else {
        const cfs = source;
        if (log_it) {
          debugger;
        }
        const combined_features = char_util.useFeatures2(char, cfs, true, log_it);
        if (log_it) {
          console.log(combined_features);
        }
        if (char instanceof Character && char.c_options.optional_features) {
          return_us.push(
            <Grid
              key="header"
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                size={{
                  xs: 12
                }}>
                <CenteredMenu 
                  selected={view}
                  options={["Current Features","Optional Features"]} 
                  onSelect={setView}                      
                />
              </Grid>
            </Grid>
          );
        }
        const char_feature_bases = combined_features.sort((a, b) => (a.feature_base && b.feature_base && a.feature_base.level > b.feature_base.level) ? 1 : -1);
        return_us.push(renderCharFeatureBases(char_feature_bases));
      } 
    }
    return (<>{return_us}</>);
  }
}
